import { render, staticRenderFns } from "./CPopup.vue?vue&type=template&id=6932234b&scoped=true"
import script from "./CPopup.vue?vue&type=script&lang=js"
export * from "./CPopup.vue?vue&type=script&lang=js"
import style0 from "./CPopup.vue?vue&type=style&index=0&id=6932234b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6932234b",
  null
  
)

export default component.exports